import * as yup from "yup";

export const inviteUserSchema = yup.object().shape({
    email: yup.string().email("Email address not valid").required("Field is required"),
});
